import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n.use(initReactI18next).init({
    resources: {
        es: {
            translation: {
                "hero-title": "SE&TI CONSTRUCTION",
                "hero-subtitle": "SE&TI REMODELING LLC is a company with 5 years of experience",
                "hero-mini": "Desde $250 al Mes",

                'hero-01': "+1900 Canales de TV y Video on Demand siempre actualizado",
                'hero-02': "+24.000 Películas",
                'hero-03': "+5.400 Series",
                'hero-04': "+80 Canales Deportivos",
                'hero-05': "Contenido Infantil, Familiar y para todas las edades",
                'hero-06': "Calidad HD estable y sin buffering",
                'hero-07': "Compatible con la mayoría de los dispositivos actuales",
                'hero-08': "Todo en Kaelus por menos de $8 diaros",
                'hero-call': "¡Comienza tu prueba gratis hoy!",

                'about-title': "Todo el contenido de tus plataformas favoritas en una misma",
                'about-subtitle': 'Descubre un nuevo mundo digital con Kaelus Tv Plus',
                'about-subtitle-02': 'Quality, Transparency, and Craftsmanship You Can Rely On.',

                'about-text-01': 'Kaelus TV es el servicio IPTV más completo y estable del mercado. Con más de 1,900 canales en vivo (incluyendo deportes, películas, series y contenido internacional en HD), tecnología anti-buffering y soporte 24/7, ofrecemos una experiencia de televisión premium por solo',
                'about-price': ' $250/mes',
                'about-text-02': '. Compatible con cualquier dispositivo',
                'about-text-03': ' (Smart TVs, Android, iOS, Fire Stick, Roku, navegadores principales como Chrome, Firefox, Edge y más)',
                'about-text-04': ', sin contratos largos y con actualizaciones diarias de contenido. ¡Disfruta de la televisión del futuro hoy mismo!',
                
                'about-call': 'Click aquí – Tu TV en HD empieza hoy',
                'about-02': 'Kaelus TV lleva entretenimiento para todos a tu hogar: desde canales infantiles y películas familiares hasta deportes y noticias globales.',
                'about-03': 'Por tan sólo $250/Mes',
                'about-feature-01': 'Hasta 3 dispositivos',
                'about-feature-02': 'Más de 1,900 canales',
                'about-feature-03': 'Cuenta con soporte 24/7',
                'about-feature-04': 'Garantizado 99.9% de uptime',

                'plan-title': 'Ofrecemos la misma excelencia en cada uno de',
                'plan-title-hightlight': 'nuestros planes',
                'plan-subtitle': 'Sin importar cuál elijas, disfrutarás de contenido completo y calidad premium en todo momento.',
                'plan-subtitle-text': 'Diseñados para adaptarse a tus necesidades, todos incluyen acceso integral a nuestros servicios, garantizando una experiencia sin límites ni restricciones.',

                'plan-mini': 'plan',
                'plan-monthly': 'Mensual',
                'plan-annual': 'Anual',
                'plan-quarterly': 'Trimestral',
                'plan-half': 'Semestral',
                'plan-save': 'Ahorro óptimo',
                'plan-device': 'Hasta 3 dispositivos simultáneos',
                'plan-text': 'Con nuestros planes podrás disfrutar del contenido de tus plataformas favoritas en una misma al mejor precio.',
                'plan-monthly-price': '$250',
                'plan-quarterly-price': '$675',
                'plan-half-price': '$1,200',
                'plan-annual-price': '$2,160',
                'plan-price-currency': 'MXN',
                'plan-btn': '¡Quiero este plan!',
                'plan-text-note': 'Con nuestros planes podrás disfrutar del contenido de tus plataformas favoritas en una misma al mejor precio.',

                'about-02-title': 'La mejor compatibilidad con tus dispositivos, hasta 3 al mismo tiempo',
                'about-02-subtitle': 'Smart TV, Android, iOS, Fire Stick, Roku, Google Chrome',
                'about-02-cta': 'whatsapp directo - resuelve tus dudas en 1 minuto',

                'reseller-title': 'Conviértete en un Revendedor',
                'reseller-subtitle': 'Únete a nuestro programa de revendedores y comienza a ganar dinero hoy mismo.',
                'reseller-text-01': 'Contamos con un sistema fácil de usar para gestionar tus ventas y comisiones. Además, ofrecemos soporte continuo para ayudarte a tener éxito.',
                'reseller-text-02': 'Al convertirte en revendedor, tendrás la oportunidad de ofrecer nuestros servicios a tus clientes, ganar comisiones y disfrutar de beneficios exclusivos.',
                'reseller-text-03': 'Como revendedor oficial de Kealus TV, tendrás acceso a una plataforma intuitiva para gestionar tus suscripciones y comisiones, además de soporte dedicado para resolver cualquier duda. Podrás ofrecer uno de los servicios de streaming más competitivos del mercado, con contenido exclusivo y alta demanda, generando ingresos recurrentes mientras tus clientes disfrutan de entretenimiento ilimitado.',
                'reseller-cta': 'Quiero ser Reseller',

                'contact-title': '¿Necesitas ayuda o quieres activar tu servicio?',
                'contact-subtitle-01': 'Horario de atención: 24/7',
                'contact-subtitle-02': '(soporte inmediato vía WhatsApp)',
                'contact-subtitle-03': 'Resuelve tus dudas al instante',
                'contact-subtitle-04': '– Configuración, pagos o soporte técnico.',
                'contact-cta': 'Activar mi prueba GRATIS',
            }
        },
        en: {
            translation: {
                "hero-title": "SE&TI REMODELING LLC",
                "hero-subtitle": "With over 5 years of experience in Clearwater and across Florida, we deliver high-quality craftsmanship and transparent communication. Let’s turn your vision into reality.",
                'hero-mini': "Transforming Florida Homes Into the Space You’ve Always Wanted",

                'hero-call': "Get Your Free Estimate",

                'about-title': "Our Story",
                'about-subtitle': 'Over 5 Years of Excellence in Florida Remodeling',
                'about-subtitle-02': 'Quality, Transparency, and Craftsmanship You Can Rely On.',

                'about-text-01': 'At SE&TI REMODELING LLC , we don’t just renovate spaces; we create the backdrop for your life. Based in Clearwater, Florida, our team has spent the last 5 years helping homeowners and businesses across the state reimagine their properties.',
    
                'about-text-02': 'We believe remodeling should be exciting, not stressful. That’s why we combine top-tier craftsmanship with clear, honest communication. From minor electrical repairs to full-scale home overhauls, every project is treated with the same passion and attention to detail. Your home is unique, and our job is to make sure your renovation reflects your personal style.',
              
                'about-highlight': '+5 Years of Experience | +100 Projects Completed | Licensed & Insured in Florida',

                'services-title': 'What We Do',
                'services-subtitle': 'Comprehensive Remodeling Solutions for Your Home or Business',
                'services-subtitle-02': 'No project is too big or too small. We handle everything with precision and care.',

                'services-list-01': 'Interior & Exterior Painting:',
                'services-text-01': 'Refresh your property’s look with high-durability paint and flawless finishes. We use products designed to withstand Florida’s humidity and sun.',

                'services-list-02': 'Flooring Installation:',
                'services-text-02': 'Expert installation of hardwood, laminate, tile, and luxury vinyl plank (LVP). We ensure durability and style that lasts for years.',

                'services-list-03': 'Kitchen Renovation:',
                'services-text-03': 'We design and build the heart of your home. From custom cabinetry to new outdoor patio kitchens, we create functional, beautiful spaces.',

                'services-list-04': 'Full Home Renovation:',
                'services-text-04': 'Dreaming of a total transformation? We manage the entire process, from initial design to final construction, remodeling your home exactly the way you want it.',

                'services-list-05': 'Plumbing & Electrical:',
                'services-text-05': 'Reliable repairs and new installations. We ensure all work meets Florida building codes for your safety and peace of mind.',

                'service-call': 'Start Your Project Today',
               

                'contact-title': 'Let’s Build Something Great Together',
                'contact-subtitle': 'Contact Us for a Free, No-Obligation Estimate',
                'contact-subtitle-02': 'Tell us about your project, and we’ll get back to you with a clear and detailed quote. No hidden costs, just honest answers.',
                'contact-cta': 'Activate my FREE Trial',

                'contact-information-01': 'Visit Us:',
                'contact-information-text-01': '2266 Gulf to Bay Boulevard Lt. 345',
                'contact-information-text-01-02': 'Clearwater, Florida. Zip. 33765',

                'contact-information-02': 'Call or Text Us:',
                'contact-information-text-02': '(727) 340-5713',

                'contact-information-03': 'Email:',
                'contact-information-text-03': 'irenetoledo@seti.company',

                'contact-call': 'Get a Free Consultation',
            }
        }
    },
    lng: "en",
    fallbacking: "en"
});
